import get from 'lodash/get'
import merge from 'lodash/merge.js'
import { useRootStore } from '~/store/root'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { $lendioCookies, $pinia } = useNuxtApp()
  const rootStore = useRootStore($pinia)

  // We need to set the tracking cookies here in the middleware using the
  // Nuxt cookie plugin, otherwise they get lost.
  // Marketing is passing several custom url params to this path. Some of the params being used are as follows, but not limited to:
  // 'capturepage', 'landing_page', 'referral_url', 'affiliate', 'medium', 'source', 'ref', 'campaign', 'subid', 'skipMarketingRecord', 'adgroup', 'term', 'keywords', 'interest'

  let queryObj = { ...to.query }
  const email = get(queryObj, 'e') || get(queryObj, 'username')
  const redirectUrl = get(queryObj, 'r')
  let isValidUrl = false

  try {
    const url = new URL(redirectUrl)
    isValidUrl = true
    console.error('Valid URL passed when expecting redirect only', { url })
  } catch (e) {
    // The catch flow is the expected path for users. No action needed, just continue
  }

  if (isValidUrl) {
    // We want to only allow relative redirects from this flow
    return nuxtApp.runWithContext(() => navigateTo('/404'))
  }

  // grab marketing params for touch if present in redirectUrl
  if (redirectUrl) {
    const decodedURL = decodeURI(redirectUrl)
    const redirectQuery = decodedURL.split('?')[1]
    const redirectQueryObj = redirectQuery
      ? redirectQuery.split('&').reduce((obj, val) => {
          let [key, value] = val.split('=')
          obj[key] = value
          return obj
        }, {})
      : {}
    queryObj = merge({}, redirectQueryObj, queryObj)
    $lendioCookies.set('redirect', redirectUrl, { maxAge: 60 * 10 })
  }

  // Set a cookie for each url query param
  Object.keys(queryObj).forEach((key) => {
    $lendioCookies.set(key, queryObj[key], { expires: 7 })
  })
})
